import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'
import './styles.scss'
import './animations.scss'

const backgrounds = {
  1: 'seilbahn.jpg',
  2: 'fussball.jpg',
  3: 'guezli.jpg',
  4: 'kunsthaus.jpg',
  5: 'velo.jpg',
  6: 'esel.jpg',
  7: 'cello.jpg',
  8: 'fuchs.jpg',
  9: 'cidre.jpg',
  10: 'engel.jpg',
  11: 'busfahrer.jpg',
  12: 'fabrikarbeiter.jpg',
  13: 'baer.jpg',
  14: 'eichhoerndli.jpg',
  15: 'wage.jpg',
  16: 'schwan.jpg',
  17: 'surprise.jpg',
  18: 'laterne.jpg',
  19: 'zwingli.gif',
  20: 'boogg.jpg',
  21: 'taube.jpg',
  22: 'blinkengel.gif',
  23: 'psychiater.jpg',
  24: 'stern.gif'
}

const animatedDoors = {
  1: (
    <div className='doorseilbahn'>
      <div className='full bahn' />
      <div className='full wand' />
      <div className='full sterne' />
    </div>
  ),
  2: (
    <div className='doorfussball'>
      <div className='ball' />
    </div>
  ),
  3: (
    <div className='doorguezli'>
      <div className='full guezli' />
      <div className='full wasser' />
    </div>
  ),
  10: (
    <div className='doordrone'>
      <div className='drone' />
      <div className='full engel' />
    </div>
  ),
  20: (
    <div className='doorboog'>
      <div className='full second gif_fade' />
    </div>
  )
}

function Picture(props) {
  const img = require(`./images/front/${backgrounds[props.no]}`)
  // const imgBackside = require(`./images/back/${1}.jpg`) // XXX REMOVE
  // const imgBackside = require(`./images/back/${props.no}.jpg`)

  const style = {}
  if (props.no === props.active) style.transform = 'rotateY(180deg)'

  return (
    <div className='picture'>
      <div
        className='flipcontainer'
        onClick={() => props.onClick(props.no)}
        style={style}
      >
        <div
          className={`front ${props.className ? props.className : ''}`}
          style={props.style}
        >
          <img src={img} />
          {/* {props.children && <div className='inner'>{props.children}</div>} */}
          {props.no in animatedDoors ? (
            <div className='inner'>{animatedDoors[props.no]}</div>
          ) : null}
          <div className='number'>{props.no}</div>
          {props.goldBorder && <div className='goldborder' />}
        </div>
        <div className='back'>
          {/* <img src={imgBackside} /> */}
          <div className='textoverlay'>
            <div className='fliptitle'>{props.title}</div>
            <div className='fliplead'>
              {props.lead}{' '}
              <Link href={props.url} target='_blank' icon='external'>
                Mehr lesen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Picture
